import { RefSerializer } from "@tblabs/truffle";
import { BlogArticle } from "../../Models/Blog/BlogArticle";
import { BlogContent } from "../../Models/Blog/BlogContent";
import { RawBlogContent } from "../../Models/Blog/RawBlogContent";
import { RawBlogArticle } from "../../Models/Blog/RawBlogArticle";
import { Converter } from "@tblabs/storage";


export class BlogContentConverter extends Converter<RawBlogContent, BlogContent>
{
    public ConvertToRaw(content: BlogContent): RawBlogContent
    {
        return RefSerializer.Flatenize(content) as RawBlogContent;
    }

    public ConvertFromRaw(raw: RawBlogContent): BlogContent
    {
        const content = new BlogContent();

        content.Articles.Load(...this.GetArray(raw.Articles, (raw: RawBlogArticle) => new BlogArticle(raw)));

        return content;
    }
}
